<template>
  <div>
    <SectionTitle
      class="mt-3"
      :has-line="true"
      :title="
        'Propósito de la consulta al facilitador docente de educación especial:'
      "
    />

    <div class="row ">
      <div class="col-12 px-4">
        <div
          v-for="purpose in purposes"
          :key="purpose.questionId"
          class="custom-control custom-checkbox mb-2"
        >
          <input
            :id="'purpose_' + purpose.questionId"
            type="checkbox"
            class="custom-control-input chk-sized"
            :checked="purpose.selected"
            :value="purpose.questionId"
            :disabled="submitted"
            @input="checked($event, purpose)"
          />
          <label
            class="custom-control-label chk-label pl-2"
            :for="'purpose_' + purpose.questionId"
            v-text="purpose.text"
          />
          <div
            v-if="purpose.questionId === otherPurposeId && purpose.selected"
            class="col-12 pl-1"
          >
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              :custom-messages="{ required: 'Favor escriba descripción.' }"
            >
              <CustomTextArea
                v-model="purpose.description"
                :disabled="submitted"
                style="width:100%"
                :maxlength="3000"
                :classes="['eq-field', 'text-right']"
                :rows="3"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from '@/components/common/CustomTextArea';
import SectionTitle from 'SectionTitle';

export const PurposeEnum = { Other: 226 };

export default {
  name: 'Purposes',
  components: {
    CustomTextArea,
    SectionTitle,
  },
  props: {
    purposes: { type: Array, default: () => [] },
    submitted: { type: Boolean, required: true, default: false },
  },
  data: () => ({
    otherPurposeId: PurposeEnum.Other,
  }),
  computed: {
    hasPurposes() {
      return this.purposes.some((p) => p.selected);
    },
  },
  methods: {
    checked({ target: { checked } }, purpose) {
      purpose.selected = checked;
      if (!checked && purpose.questionId === this.otherPurposeId) {
        purpose.description = null;
      }
    },
  },
  watch: {
    purposes: {
      handler() {
        this.$emit('input', this.hasPurposes);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.chk-sized {
  width: 20px;
  height: 20px;
}
.chk-label {
  font: normal normal normal 16px/19px Lato;
  letter-spacing: 0px;
  color: #11291b !important;
}
.chk-label::before,
.chk-label::after {
  width: 20px !important;
  height: 20px !important;
  top: 0;
}
</style>
